import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Avatar, Grid, Paper, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";

export default function Service({icon, title, description, elevation=1}) 
{
    const {t, i18n} = useTranslation();

    return(
        <Grid item xs={12} sm={12} md={12} lg={12} xl={12} sx={{display:'flex',height:'100%'}}>
            <Paper elevation={elevation} sx={{borderRadius:10,padding:5}}>
                <Grid container spacing={3} alignItems={'center'}>
                    <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                        <Avatar sx={{ bgcolor: '#ebeef6', width: 60, height: 60 }}>
                            <FontAwesomeIcon icon={icon} color={'#147ac2'} style={{fontSize:28}}/>
                        </Avatar>
                    </Grid>

                    <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                        <Typography variant='h6' component={'h1'} color={'primary.main'} fontWeight={'bold'}>
                            {title}
                        </Typography>
                        <Typography variant='h6' component={'h1'} color={'#5A5A5A'} sx={{ whiteSpace: 'pre-line' }}>
                            {description}
                        </Typography>
                    </Grid>
                </Grid>
            </Paper>
        </Grid>
    )
}